export const contactModalActions = {
  SHOW_CONTACT_MODAL: 'SHOW_CONTACT_MODAL',

  showContactModal: (payload: boolean) => ({
    type: contactModalActions.SHOW_CONTACT_MODAL,
    payload,
  }),
};
